import { useEffect, useRef } from 'react';

interface ParallaxElement {
  element: HTMLElement;
  speed: number;
  direction: 'up' | 'down';
}

export const useParallax = () => {
  const elementsRef = useRef<ParallaxElement[]>([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const rate = scrolled * -0.1; // Muy reducido

      elementsRef.current.forEach(({ element, speed, direction }) => {
        if (element) {
          const yPos = direction === 'up' ? rate * speed : -(rate * speed);
          element.style.transform = `translateY(${yPos}px)`;
        }
      });
    };

    const initParallax = () => {
      // Limpiar elementos previos
      elementsRef.current = [];

      // SOLO elementos de fondo decorativos - NO CARDS DE NINGÚN TIPO
      const backgroundElements = document.querySelectorAll('.contact-background-pattern, .hero-background-element');
      backgroundElements.forEach((element) => {
        elementsRef.current.push({
          element: element as HTMLElement,
          speed: 0.03,
          direction: 'up'
        });
      });

      // Explícitamente resetear cualquier transform en benefit-cards
      const benefitCards = document.querySelectorAll('.benefit-card');
      benefitCards.forEach((card) => {
        (card as HTMLElement).style.transform = '';
      });
    };

    // Inicializar después de que el DOM esté listo
    const timer = setTimeout(initParallax, 500);

    // Añadir listener de scroll optimizado
    let ticking = false;
    const requestTick = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', requestTick, { passive: true });

    return () => {
      window.removeEventListener('scroll', requestTick);
      clearTimeout(timer);
      // Limpiar transforms
      elementsRef.current.forEach(({ element }) => {
        if (element) {
          element.style.transform = '';
        }
      });
      
      // Asegurar que benefit-cards no tengan transforms
      const benefitCards = document.querySelectorAll('.benefit-card');
      benefitCards.forEach((card) => {
        (card as HTMLElement).style.transform = '';
      });
    };
  }, []);

  return { elementsRef };
};
